.bx{max-width:100%;}